export const LOAD_PERDIEM_REQUEST_APPROVAL_DETAILS = "LOAD_PERDIEM_REQUEST_APPROVAL_DETAILS"
export const loadPerdiemRequestApprovalDetailsAction = pagination => ({
   type: LOAD_PERDIEM_REQUEST_APPROVAL_DETAILS,
   payload: pagination
})